<template>
  <div class="webdev-box">
    <div class="en-title">{{ "Website".toUpperCase() }}</div>
    <div class="cn-title">高端网站定制开发</div>
    <div v-html="cleanHtmlText(data.content)"></div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
